import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import InfoIcon from "@material-ui/icons/Info";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const useStyles = makeStyles(() => ({
  dialogTitle: {
    minWidth: "400px",
    borderBottom: "1px solid #80808057",
    padding: "10px 24px",
    fontWeight: 600,
  },
  dialogContent: {
    paddingTop: "16px",
  },
  alertBox: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
  },
  alertIcon: {
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
  },
  alertMessage: {
    fontWeight: 500,
    flex: 1,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
}));

const   getSeverityColors = (severity) => {
  switch (severity) {
    case "success":
      return {
        bg: "#28ae60",
        color: "#FFFFFF",
        iconColor: "#FFFFFF",
      };
    case "warning":
      return {
        bg: "#ffa716",
        color: "#FFFFFF",
        iconColor: "#FFFFFF",
      };
    case "error":
      return {
      bg: "#fef3f0",
      color: "#fe6d3a",
      iconColor: "#fe6d3a",
      };
    case "info":
      return {
        bg: "#fef3f0",
        color: "#fe6d3a",
        iconColor: "#fe6d3a",
      };
    default:
      return {
        bg: "#9E9E9E",
        color: "#FFFFFF",
        iconColor: "#FFFFFF",
      };
  }
};

const getSeverityIcon = (severity, iconColor) => {
  const style = { color: iconColor };
  switch (severity) {
    case "success":
      return <CheckCircleOutlineOutlinedIcon style={style} />;
    case "warning":
      return <InfoOutlinedIcon style={style} />;
    case "error":
      return <ErrorOutlineOutlinedIcon style={style} />;
    case "info":
      return <InfoIcon style={style} />;
    default:
      return <InfoIcon style={style} />;
  }
};

export default function AlertDialog(props) {
  const classes = useStyles();

  const handleClose = () => {
    props.closeAlert();
  };

  const severity = props.severity || "error";
  const colors = getSeverityColors(severity);

  const getTitle = () => {
    if (props.alertTitle) return props.alertTitle;
    return severity === "success" || severity === "warning"
      ? "Message"
      : "Error";
  };

  const renderMessage = () => {
    if (Array.isArray(props.alertMsg)) {
      return props.alertMsg.map((item, indx) => (
        <p
          key={indx}
          style={{
            margin: indx === props.alertMsg.length - 1 ? 0 : "0 0 8px 0",
          }}
        >
          {item}
        </p>
      ));
    }
    return props.alertMsg;
  };

  return (
    <Dialog
      open={props.showAlert}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        className={classes.dialogTitle}
        disableTypography
      >
        {getTitle()}
      </DialogTitle>
      <DialogContent className={classes.dialogContent} style={{ paddingBottom: "16px" }}>
        <Box
          className={classes.alertBox}
          style={{
            backgroundColor: colors.bg,
            color: colors.color,
            border: `1px solid ${colors.color}`,
          }}
        >
          <span className={classes.alertIcon}>
            {getSeverityIcon(severity, colors.iconColor)}
          </span>
          <span className={classes.alertMessage}>{renderMessage()}</span>
          <IconButton
            size="small"
            onClick={handleClose}
            className={classes.closeButton}
          >
            <CloseIcon fontSize="small" style={{ color: colors.iconColor }} />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
